const KEY = "wp_cookie_consent_v1";

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch (_e) {
    return null;
  }
};

export const saveConsent = ({ analytics, marketing }) => {
  const prev = getConsent();
  const next = {
    necessary: true,
    analytics: !!analytics,
    marketing: !!marketing,
    updated_at: new Date().toISOString(),
  };
  localStorage.setItem(KEY, JSON.stringify(next));
  if (next.analytics) window.wpStartAnalytics?.();
  else if (prev?.analytics) window.wpStopAnalytics?.();
  window.dispatchEvent(new Event("wp-consent-changed"));
  return next;
};

export const openConsentSettings = () => window.dispatchEvent(new Event("wp-open-consent"));
